export const webAppSettings = (destinationLang) => {
  return [
    {
      FormKey: 'web-app-settings-login-by-phone-number',
      Key: 'امکان ورود با شماره همراه',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'web-app-settings-reset-password',
      Key: 'فعالسازی فراموشی رمز',
      DistinitationLanguage: destinationLang,
    },
  ];
};
